import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
import MaterialTable from "material-table";
import { forwardRef } from 'react';
import { CSVLink } from "react-csv";


import { api_host, api_auth } from '../../../../../common/globals/constants';

import PortletContent from 'components/PortletContent';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment'
import 'moment/locale/es'  
moment.locale('es')


class Data extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            nameObjective: this.props.match.params.nombre_objetivo,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            step: null,
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            data: null,
            dataTab: null,
            //value: ',',
            noMonCum: null,
            downCum: null,
            date: this.props.params.date,
            dateMoment: ((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")),
            isRefresh: this.props.params.isRefresh,
            beginDate: null,
            endDate: null,
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.params.period !== prevState.time) {

            return {
                externalData: null,
                data:null,
                //prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                rows: null,
                statePeriod: nextProps.params.statePeriod,
                //isStatePeriod: nextProps.params.isStatePeriod
            }
        } else if(nextProps.params.isRefresh !== prevState.isRefresh){
            return {
                externalData: null,
                //prevObjectiveId: props.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                rows: null,
                statePeriod: nextProps.params.statePeriod,
                isRefresh: nextProps.params.isRefresh,          
            }

        } else if (nextProps.params.statePeriod !== prevState.statePeriod) {
            return {
                //prevObjectiveId: props.match.params.objetivo_id,
                data:null,
                time: nextProps.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                rows: null,
                statePeriod: nextProps.params.statePeriod,
                isStatePeriod: nextProps.params.isStatePeriod
            }
        }
        return null;
    }


    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }

        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.params.isRefresh !== this.state.isRefresh) ||
            (prevProps.params.statePeriod !== this.state.statePeriod)) {                
            this.getDataFromAPI();
        }

    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        const { objetivo_id } = this.props.match.params
        const { fromObjective } = this.props.location.state
        const { period, statePeriod, step, isStepDowntime } = this.props.params
        const { history } = this.props;
        const {time} = this.state

        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        
        if (period === 'c') {
            fecha_inicio = moment(statePeriod.startDate).format('YYYY-MM-DD')
            fecha_inicio = fecha_inicio+' 00:00'
            fecha_termino = moment(statePeriod.endDate).add({"days":1}).format('YYYY-MM-DD')
            fecha_termino = fecha_termino+' 00:00'
            fetch(api_host + `/reporte/online/general/getDataCustom/?objetive=${objetivo_id}&inicio=${fecha_inicio}&termino=${fecha_termino}&user=${user}&period=${period}`)
            .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);             
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                'step',
                                period,
                                fecha_inicio,
                                fecha_termino)
                        } catch (error) {
                            console.log(error)
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                });
        } else {
            let finalTime = (moment().format('YYYY-MM-DD HH:mm'))
            let beginTime = (moment().subtract(1, "hours").format('YYYY-MM-DD HH:mm'))
            if (this.state.time === 'd') {
                beginTime = (moment().subtract(1, "days").format('YYYY-MM-DD HH:mm'))
            } else if (this.state.time === 'w') {
                beginTime = (moment().subtract(1, "weeks").format('YYYY-MM-DD HH:mm'))
            } else if (this.state.time === '3h') {
                beginTime = (moment().subtract(3, "hours").format('YYYY-MM-DD HH:mm'))
            } else if (this.state.time === '3d') {
                beginTime = (moment().subtract(3, "days").format('YYYY-MM-DD HH:mm'))
            }
            fetch(api_host + `/reporte/online/general/getDataCustom/?objetive=${objetivo_id}&inicio=${beginTime}&termino=${finalTime}&user=${user}&period=${time}`)
            .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);             
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                'step',
                                period,
                                beginTime,
                                finalTime)
                        } catch (error) {
                            console.log(error)
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                });

        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (data,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        step,
        period,
        fecha_inicio,
        fecha_termino) => {
            
            var arrayData = []
            var arrayDataTab = []
            //var dictNombre = {}
            //dictNombre['Datos Objetivo'] = '__nombre_objetivo'
            var result ="Datos Objetivo: {__nombre_objetivo}\n\n"+"Leyenda \n"+"   Servidor : servidor que realizo el monitoreo. \n"+
            "   Fecha : fecha cuando se realizo el monitoreo. \n"+"   Hora : hora cuando se realizo el monitoreo. \n"+
            "   Status : codigo de estado del monitoreo. \n"+"   Delay : tiempo de respuesta del monitoreo. \n"+"\nCodigos de Estados\n"
            //dictNombre['Datos Objetivo'] = '__nombre_objetivo'
            //dictNombre['Datos Objetivo'] = '__nombre_objetivo'
            //arrayData.push(result)
            Object.values(data['data_monitores']).map(key =>{
                
                Object.values(key['data_monitor']).map(keyDataMonitor =>{
                    var dict = {};
                    var dictTab = {}
                    dict['servidor'] = key['monitor']
                    dict['fecha'] = keyDataMonitor['fecha'].substring(0,10)
                    dict['hora'] = keyDataMonitor['fecha'].substring(11,19)
                    dictTab['servidor'] = key['monitor']
                    dictTab['fecha'] = keyDataMonitor['fecha'].substring(0,10)
                    dictTab['hora'] = keyDataMonitor['fecha'].substring(11,19)
                    var cont = 0
                    var arrayStatus = []
                    var arrayResponse = []
                    Object.values(keyDataMonitor['data']).map(keyData =>{
                        var dictStatus = {}
                        var dictResponse = {}
                        cont = cont + 1
                        dict[keyData['nombre_paso']+' - estado '+cont] = keyData['estado']
                        dict[keyData['nombre_paso']+' - respuesta '+cont] = keyData['respuesta']
                        
                        dictStatus[keyData['nombre_paso']+' - estado '+cont] = keyData['estado']
                        dictResponse[keyData['nombre_paso']+' - respuesta '+cont] = keyData['respuesta']
                        arrayStatus.push(dictStatus)
                        arrayResponse.push(dictResponse)
                        
                    })
                    
                    arrayStatus.forEach(function(value, key){
                        dictTab[Object.entries(value)[0][0]] = Object.entries(value)[0][1] 
                    })
                    arrayResponse.forEach(function(value, key){
                        dictTab[Object.entries(value)[0][0]] = Object.entries(value)[0][1] 
                    })
                    arrayData.push(dict)
                    arrayDataTab.push(dictTab)
                })
            })
            

            this.setState({
                data: arrayData,
                dataTab: arrayDataTab,
                beginDate: fecha_inicio,
                endDate: fecha_termino,
                //noMonCum : noMonCumDate,
                //downCum : downCumDate,
                isLoading: false,
                //time: period,
                //step: step,
                dataError: false,
            }); 
       
    }

    handleChange = event => {
        this.setState({value: event.target.value});
      };

    render() {
        const { dataError, isLoading, data, noMonCum, downCum, dataTab, value, nameObjective, beginDate, endDate } = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' }; 
        if (!dataError) {
            return (<FormattedChart handleChange={this.handleChange} value={value} 
                                    data={data} dataTab={dataTab} noMonCum={noMonCum} downCum={downCum} 
                                    isLoading={isLoading} style={style} styleHidden={styleHidden} 
                                    nameObjective={nameObjective} beginDate={beginDate} endDate={endDate} />) 
        }
        else if (dataError) {
            return (<p>No hay datos..</p>)
        }
        else return (<p> Error!</p >)

    }
}

function FormattedChart(props) {
    return (
        <div>
            { props.data == null  ? 
                <PortletContent>
                    <PerfectScrollbar>

                        <Typography
                        variant="h5"
                        >
                        <CircularProgress
                        variant="indeterminate"

                        size={24}
                        thickness={4}
                        
                        />
                        <br/>
                        Cargando Información...
                    </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            :
                <div style={{ maxWidth: "100%" }}>
                    
                            
                    <Table>
                        <TableRow>
                            <TableCell style={{borderBottom: "none"}}>
                                <Typography
                                    variant="h6"
                                    >
                                    Juego de Caracteres
                                            </Typography>
                            </TableCell>
                            <TableCell style={{borderBottom: "none"}}>
                                <FormControl /*className={classes.formControl}*/> 
                                    
                                    <NativeSelect
                                        //className={classes.textFieldSelect}
                                        /*onChange={event =>
                                            this.handleFieldChange('destinatario', event.target.value)
                                        }*/
                                        defaultValue={1}
                                        inputProps={{
                                            name: 'name',
                                            id: 'uncontrolled-native',
                                        }}
                                    >
                                        {/*<option value={0}>Windows (LATIN1)</option>*/}
                                        <option value={1}>Otros (UTF-8)</option>
                                        
                                    </NativeSelect>
                                </FormControl> 
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <Typography
                                    variant="h6"
                                    >Separador</Typography>
                            </TableCell>
                            <TableCell>
                                <FormControl component="fieldset">
                                    
                                    <RadioGroup defaultValue={","} aria-label="gender" name="customized-radios"  onClick={props.handleChange}>
                                        <FormControlLabel value="," control={<Radio />} label="Coma" />
                                        <FormControlLabel value=";" control={<Radio />} label="Punto y coma" />
                                        
                                    </RadioGroup>
                                </FormControl>
                            </TableCell>
                        </TableRow> 
                        <TableRow>
                            <TableCell style={{borderBottom: "none"}}>
                                <CSVLink data={props.dataTab} separator={props.value} filename={props.nameObjective+"("+props.beginDate+" a "+props.endDate+").csv"}>
                                    <Button variant="contained" color="primary" size="small">Descargar CSV</Button>
                                </CSVLink>
                                
                            </TableCell>
                            <TableCell style={{borderBottom: "none"}}>
                                <CSVLink data={props.data} separator={props.value} filename={props.nameObjective+"("+props.beginDate+" a "+props.endDate+")tabulado.csv"}> 
                                    <Button variant="contained" color="primary" size="small">Descargar CSV Tabulado</Button>
                                </CSVLink>
                                    </TableCell>
                        </TableRow>            
                    </Table>        
                            
                
                </div>}
            </div>
        )

}


export default withRouter(Data);